<!-- 相关ETF联接基金 -->
<template>
  <div
    v-if="!$isEmpty(fundInfo) && !$isEmpty(fundInfo.fundName)"
    @click="$goFundApp"
    class="etf-relate-fund">
    <div class="top-header row">
      <div>相关ETF联接基金</div>
      <div class="more row">
        <div>详情</div>
        <img :src="RIGHT_ARROW" class="arrow"/>
      </div>
    </div>
    <div class="content row">
      <img v-if="!$isEmpty(fundInfo.chartUrl)"
        :src="fundInfo.chartUrl"
        class="chart-img" />
      <div v-else class="img-placeholder chart-img">成立未满6月</div>
      <div class="fund-info">
        <div class="fund-name">{{fundInfo.fundName}}</div>
        <div class="detail row">
          <div class="syl row">
            <div class="fund-name">{{fundInfo.date}}</div>
            <div v-if="!$isEmpty(fundInfo.value)" :style="{ color: getRateColor(fundInfo.value)}"
              class="value"
              >{{fundInfo.value}}</div>
          </div>
          <div :class="fundInfo.canBuy ?
            ['buy-btn', 'active']
            : ['buy-btn', 'disabled']">去购买</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import tool from '@/utils/tool';

export default {
  name: 'etf-relate-fund',

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fundInfo: {},
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  watch: {
    detailInfo: {
      deep: true,
      immediate: true,
      handler() {
        if (this.basicInfo?.isETF && !this.$isEmpty(this.detailInfo)
          && !this.$isEmpty(this.detailInfo?.indexCode)
          && !this.$isEmpty(this.detailInfo?.companyId)) {
          this.getETFData();
        }
      },
    },
  },

  methods: {

    getRateColor: tool.getRateColor,

    getETFData() {
      this.$http.useRequests('FundComApi.getETFInfo', {
        INDEXCODE: this.detailInfo?.indexCode,
        sortColumn: 'SYL_1N',
        FIELDS: 'FCODE,SHORTNAME,SYL_1N,ESTABDATE,SYL_6Y,ISBUY,JJGSID',
      }).then((res) => {
        console.log('get ETF', res);
        // TODO eventBus
        if (!this.$isEmpty(res?.data)) {
          const filterData = res.data.filter((item) => item.JJGSID === this.detailInfo?.companyId);
          if (!this.$isEmpty(filterData)) {
            this.fundInfo = {
              fundName: filterData[0].SHORTNAME,
              fundCode: filterData[0].FCODE,
              canBuy: [1, 2, 3, 8, 9].indexOf(parseInt(filterData[0].ISBUY, 10)) >= 0,
              ...this.getSyl(filterData[0].SYL_1N, filterData[0].SYL_6Y, filterData[0].FCODE),
            };
            console.log('get ETF fundInfo', this.fundInfo);
          }
        }
      }).catch((err) => { console.log('get ETFRelateInfo ERR', err); });
    },

    getSyl(oneYear, sixMonth, fundCode) {
      if (!this.$isEmpty(oneYear)) {
        return {
          date: '近1年',
          value: `${numeral(oneYear).format('0.00')}%`,
          chartUrl: `https://j3.dfcfw.com/images/apphome1/SYL_1N/${fundCode}.png`,
        };
      }
      if (!this.$isEmpty(sixMonth)) {
        return {
          date: '近6月',
          value: `${numeral(sixMonth).format('0.00')}%`,
          chartUrl: `https://j3.dfcfw.com/images/apphome1/SYL_6Y/${fundCode}.png`,
        };
      }
      return { date: '--', value: '--' };
    },
  },
};
</script>

<style lang="less" scoped>
.etf-relate-fund {
  width: 100%;
  background-color: #ffffff;
  margin: 24px 0 24px;
  box-sizing: border-box;
  padding: 40px 24px;
  border-radius: 12px;
  .top-header {
    justify-content: space-between;
    font-size: 28px;
    color: #666666;
    img {
      width: 32px;
      height: 32px;
      margin-left: 8px;
    }
  }
  .content {
    flex: 1;
    justify-content: flex-start;
    margin-top: 44px;
    overflow: hidden;
    .chart-img {
      width: 100px;
      height: 100px;
    }
    .img-placeholder {
      text-align: center;
      line-height: 40px;
      font-family: PingFangSC-Regular;
      font-size: 24px;
      color: #999999;
    }
    .fund-info {
      flex: 1;
      margin-left: 25px;
      overflow: hidden;
      .fund-name {
        width: 100%;
        font-size: 30px;
        line-height: 30px;
        color: #000000;
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
      .detail {
        margin-top: 10px;
        justify-content: space-between;
        .syl {
          font-size: 28px;
          color: #666666;
          .value {
            font-family: DINAlternate-Bold;
            font-size: 48px;
            color: #000000;
            margin-left: 16px;
          }
        }
        .buy-btn {
          padding: 0 24px;
          border-radius: 28px;
          font-size: 28px;
          height: 54px;
          box-sizing: border-box;
          line-height: 54px;
        }
        .active {
          border: 1px solid #FA5914;
          color: #FF4900;
        }
        .disabled {
          border: 1px solid #999999;
          color: #999999;
        }
      }
    }
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
